import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { type Route } from "@route-types/Global/+types/GlobalPage";
import { fetchGlobalPageData } from "@routes/Global/GlobalPage.server";
import { GlobalPageContext } from "@routes/Global/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import GlobalPageContent from "./GlobalPageContent";

const GlobalPage = (): React.ReactElement => {
  const context = useLoaderData<GlobalPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <GlobalPageContent {...context.payload.data} />;
};

export default GlobalPage;

export const loader = async () => await fetchGlobalPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as GlobalPageContext;
  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
